module.exports = __webpack_public_path__ + "img/1985.d59370f4.jpg";